import { selectOptionConvert } from '../../helpers/selectOptionConvert';
import { RetirementBase } from '../Base/Retirement';

export const TKARetirement = selectOptionConvert(RetirementBase);
